<template>
  <div
    :class="{ messages__chat_scope: true, 'messages__chat_scope--has_open_chat': currentChat }"
    role="region"
    aria-labelledby="inbox_header"
  >
    <template v-if="shouldRenderNoChats">
      <no-chats v-bind="noChatsProps" />
    </template>
    <template v-else>
      <div class="messages__chat_scope__chats">
        <chats />
      </div>
      <div class="messages__chat_scope__chat">
        <chat v-if="currentChat && isCurrentChatLoaded" :key="$route.params.chat" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Chats from './Chats.vue'
import Chat from './Chat.vue'
import NoChats from './NoChats.vue'
import { isMemberChatScope } from './route_helpers'
export default {
  name: 'ChatScope',
  components: { NoChats, Chats, Chat },
  props: {
    helpCenterURL: { type: String, required: true },
    discoverPath: { type: String, required: true }
  },
  computed: {
    ...mapGetters(['getChatScopeByPath', 'getChatPartnerId', 'getChatScopes', 'getChat']),
    currentChatScope() {
      return this.getChatScopeByPath(this.$route.params.chatScope)
    },
    currentChat() {
      return this.$route.params.chat
    },
    isCurrentChatLoaded() {
      const partnerId = this.getChatPartnerId(this.$route.params.chatScope, this.$route.params.chat)
      const chat = this.getChat(this.$route.params.chatScope, partnerId)
      return !!chat
    },
    shouldRenderNoChats() {
      return this.currentChatScope && this.currentChatScope.total_chat_count === 0
    },
    noChatsProps() {
      let type
      if (isMemberChatScope(this.$route)) {
        type = 'member'
      } else {
        type = 'publisher'
      }
      return { type, discoverPath: this.discoverPath, helpCenterURL: this.helpCenterURL }
    }
  }
}
</script>
